<div class="dashboard__area section-pb-120" style="margin-top: 5%">
  <div class="container">
    <div class="row">
      <div class="col-lg-3">
        <div class="dashboard__sidebar-wrap">
          <div class="dashboard__sidebar-title mb-20">
            <h6 class="title">Welcome, {{ Name }}</h6>
          </div>
          <nav class="dashboard__sidebar-menu">
            <ul class="list-wrap">
              <li [class.active]="formopen === 0">
                <a href="#" (click)="openComponent(0)">
                  <i class="fa fa-user"></i> My Profile
                </a>
              </li>
              <li [class.active]="formopen === 1">
                <a href="#" (click)="openComponent(1)">
                  <i class="fa fa-history"></i> Invoices History
                </a>
              </li>
              <!-- <li [class.active]="formopen === 2">
                        <a href="#" (click)="openComponent(2)">
                          <i class="fa fa-file-alt"></i> Vendor Information Change Request
                        </a>
                      </li> -->
              <li [class.active]="formopen === 3">
                <a href="#" (click)="openComponent(3)">
                  <i class="fa fa-receipt"></i> Purchase Order History
                </a>
              </li>
            </ul>
          </nav>
          <div class="dashboard__sidebar-title mt-30 mb-20">
            <h6 class="title">User</h6>
          </div>
          <nav class="dashboard__sidebar-menu">
            <ul class="list-wrap">
              <li>
                <a href="#" (click)="logout()">
                  <i class="fa fa-sign-out-alt"></i> Logout
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div class="col-lg-9">
        <div class="dashboard__content-wrap dashboard__content-wrap-two">
          <div class="dashboard__content-title">
            <div *ngIf="formopen === 0">
              <h4 class="title">My Profile</h4>
            </div>
            <div *ngIf="formopen === 1">
              <h4 class="title">Invoice History</h4>
            </div>
            <div *ngIf="formopen === 2">
              <h4 class="title">Vendor Information Change Request Form</h4>
            </div>
            <div *ngIf="formopen === 3">
              <h4 class="title">Purchase order history</h4>
            </div>
          </div>

          <div class="row">
            <div *ngIf="formopen === 0">
              <div class="profile__content-wrap">
                <ul class="list-wrap">
                  <li><span>Vendor Name:</span> {{ Name || "NA" }}</li>
                  <li><span>Vendor ID:</span> {{ vendorNumber || "NA" }}</li>
                  <li><span>User Email:</span> {{ Email || "NA" }}</li>
                  <li><span>Address:</span> {{ Address || "NA" }}</li>
                  <!-- <li>
                          <span>Request Status:</span>
                          <span
                            [ngClass]="{
                              'status-in-progress': Status === 'Vendor Change Request is In Progress',
                              'status-completed': Status === 'Vendor Change Request is Completed',
                            }"
                            [style.color]="
                              Status === 'Vendor Change Request is In Progress'
                                ? 'lightcoral'
                                : Status === 'Vendor Change Request is Completed'
                                  ? 'green'
                                  : 'inherit'
                            "
                          >
                            {{ Status }}
                          </span>
                        </li> -->
                  <li
                    [hidden]="Status !== 'Vendor Change Request is Completed'"
                  >
                    <span>Request Completion Day:</span>{{ CompletionDate }}
                  </li>
                </ul>
              </div>
              <!-- <div class="col-lg-4 col-md-4 col-sm-6">
                           <div class="dashboard__counter-item">
                               <div class="icon">
                                  <i class="skillgro-book"></i>
                              </div> 
                              <div class="content"> 
                                  <span class="count odometer" data-count="30"></span> 
                                  <p>ENROLLED COURSES</p> 
                               </div> 
                          </div> 
                      </div>
                      <div class="col-lg-4 col-md-4 col-sm-6">
                          <div class="dashboard__counter-item">
                              <div class="icon">
                                  <i class="skillgro-tutorial"></i>
                              </div>
                              <div class="content">
                                  <span class="count odometer" data-count="10"></span>
                                  <p>ACTIVE COURSES</p>
                              </div>
                          </div>
                      </div>
                      <div class="col-lg-4 col-md-4 col-sm-6">
                          <div class="dashboard__counter-item">
                              <div class="icon">
                                  <i class="skillgro-diploma-1"></i>
                              </div>
                              <div class="content">
                                  <span class="count odometer" data-count="7"></span>
                                  <p>COMPLETED COURSES</p>
                              </div>
                          </div>
                      </div> -->
            </div>
            <div *ngIf="formopen === 1">
              <app-invoice-history></app-invoice-history>
            </div>
            <div *ngIf="formopen === 2">
              <app-information-change-request></app-information-change-request>
            </div>
            <div *ngIf="formopen === 3">
              <app-purchase-order-history></app-purchase-order-history>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
